import { type ReactNode, useState } from "react";

import { RawBlocksContext } from "@/context/raw-blocks";

interface RawBlocksProviderProps {
  children: ReactNode;
}

export const RawBlocksProvider = ({ children }: RawBlocksProviderProps) => {
  const [showRawBlocks, setShowRawBlocks] = useState(false);

  return (
    <RawBlocksContext.Provider value={{ showRawBlocks, setShowRawBlocks }}>
      {children}
    </RawBlocksContext.Provider>
  );
};
